var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalarySacrifice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2661_2107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1691 11.1654C13.9772 10.3551 13.6738 9.66729 13.214 9.03664C12.9971 8.73911 12.5763 8.73911 12.3593 9.03652C11.8991 9.66721 11.5945 10.3551 11.4026 11.1654C10.6221 11.1364 9.9034 11.2296 9.19086 11.4698C8.84418 11.5866 8.70318 12.0101 8.90948 12.3237C9.33696 12.9734 9.86474 13.4841 10.5471 13.9146C10.2825 14.6687 10.1564 15.4055 10.1488 16.1789C10.145 16.5688 10.4968 16.8475 10.8533 16.7317C11.5636 16.5011 12.1873 16.1416 12.785 15.6138C13.3828 16.1416 14.0075 16.5011 14.7184 16.7318C15.0749 16.8475 15.4268 16.5688 15.4229 16.1789C15.4153 15.4055 15.2891 14.6687 15.0245 13.9146C15.7069 13.4841 16.2347 12.9734 16.6622 12.3237C16.8685 12.0101 16.7275 11.5866 16.3808 11.4698C15.6682 11.2296 14.9496 11.1364 14.1691 11.1654Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99436 14.1138C6.31229 14.5556 5.59712 14.894 4.82339 15.1451C4.19751 15.3484 3.57972 14.859 3.58643 14.1746C3.59976 12.8166 3.82127 11.5229 4.28591 10.1988C3.08769 9.44291 2.16098 8.54613 1.41039 7.40527C1.04816 6.85469 1.29571 6.11112 1.90447 5.9059C3.15558 5.48416 4.41752 5.32048 5.78792 5.37146C6.12491 3.94867 6.6597 2.74085 7.46775 1.63346C7.84881 1.11124 8.58786 1.11124 8.96866 1.63367C9.77577 2.74101 10.3086 3.94876 10.6456 5.37146C12.016 5.32048 13.2779 5.48416 14.529 5.9059C15.0214 6.07186 15.2774 6.58986 15.1658 7.07316C15.1535 7.12634 15.1368 7.1791 15.1154 7.23092",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2661_2107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalarySacrifice);
export default __webpack_public_path__ + "static/media/salary_sacrifice.511ec34e2eea159c882a3986a3868fe2.svg";
export { ForwardRef as ReactComponent };